import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import Skusequence from "../../components/skusequence.js";
import DPData from '../../components/dpdata.js'
import MasterData from '../../components/masterdata.js'
import DemandPlanRunRate from "../../components/demandplanrunrate2.js"

import "../../assets/css/inventorymanagement.css"

const NewScreen = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);

  // 🌟 Get and set query param
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get("tab") || "master";
  const [activeTab, setActiveTab] = useState(defaultTab);

  useEffect(() => {
    setSearchParams({ tab: activeTab });
  }, [activeTab, setSearchParams]);

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
  };

  const closeAlert = () => {
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
  };

  return (
    <>
      <div className="container-fluid mt-3">
        <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
          <div className="col-sm-12 p-0">
            <h1 
              className="col-sm-12" 
              style={{ 
                color: "#B9366D", 
                fontSize: "18px", 
                fontWeight: "bold", 
                fontFamily: "sans-serif" 
              }}
            >
              Masters & DP
            </h1>
          </div>

          {/* Tabs Navigation */}
          <div className="col-sm-12 p-0 mt-3">
            <ul className="nav nav-tabs" id="dpMasterTabs" role="tablist" style={{ borderBottom: "1px solid #dee2e6" }}>
              {[
                { id: "master", label: "Master Data" },
                { id: "dp", label: "DP Data" },
                { id: "runrate", label: "DP Run Rate" },
                { id: "skusequence", label: "SKU Sequence" },
              ].map((tab) => (
                <li key={tab.id} className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
                    onClick={() => setActiveTab(tab.id)}
                    type="button"
                    role="tab"
                    aria-controls={tab.id}
                    aria-selected={activeTab === tab.id}
                    style={{
                      fontSize: "14px",
                      fontWeight: activeTab === tab.id ? "600" : "500",
                      color: activeTab === tab.id ? "#93385D" : "#555",
                      backgroundColor: activeTab === tab.id ? "#fff" : "#f8f9fa",
                      borderBottom: activeTab === tab.id ? "2px solid #93385D" : "none"
                    }}
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Tab Content */}
          <div className="tab-content col-sm-12 p-0" id="dpMasterTabsContent">
            {activeTab === "master" && (
              <div className="mt-2">
                <MasterData />
              </div>
            )}
            {activeTab === "dp" && (
              <div className="mt-2">
                <DPData />
              </div>
            )}
            {activeTab === "runrate" && (
              <div className="mt-2">
                <DemandPlanRunRate />
              </div>
            )}
            {activeTab === "skusequence" && (
              <div className="mt-2">
                <Skusequence />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
      <div className={`overly-block ${overlyBlock}`} onClick={hideOverlySlideBlock}></div>
    </>
  );
};

export default NewScreen;